"use client";

import { useParams } from "next/navigation";
import { Suspense } from "react";
import { NewsListPage } from "../../skin/news";
import { MediaListPage } from "../../skin/media";
import { SsgoiTransition } from "@ssgoi/react";
import { AppPageTitle } from "@/widgets";
import { Loading } from "@/shared";

export function ArticleListPage() {
  const params = useParams<{ slug: string }>();
  const slug = params?.slug;

  return (
    <Suspense>
      <SsgoiTransition id="/app/articles">
        <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
          <AppPageTitle />
        </div>

        {slug === "news" && <NewsListPage />}
        {slug === "media" && <MediaListPage />}
        {slug !== "news" && slug !== "media" && <Loading />}
      </SsgoiTransition>
    </Suspense>
  );
}
